import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

import { createCountStore } from '@stores/create-count-store';

import { ConfettiProps, ConfettiExplosion, injectKeyframes, createParticles } from './confetti';

export const confettiStore = createCountStore();

type ConfettiOptions = ConfettiProps & {
  onComplete?: () => void;
};

let confettiRegistry: { options: ConfettiOptions } | null = null;

export const triggerConfetti = (options: ConfettiOptions = {}) => {
  confettiRegistry = { options };
  confettiStore.increase();
};

const completeConfetti = () => {
  if (confettiRegistry?.options?.onComplete) {
    confettiRegistry.options.onComplete();
  }
  confettiRegistry = null;
  confettiStore.reset();
};

export const getConfettiOptions = () => confettiRegistry?.options;

export const ConfettiProvider = () => {
  const { useStore } = confettiStore;
  const particles = useRef(createParticles());
  const isActive = useStore((s) => s.count > 0);
  const confettiOptions = getConfettiOptions();
  useEffect(() => {
    injectKeyframes({ particles: particles.current });
  }, []);

  return (
    <>
      {isActive &&
        confettiOptions &&
        createPortal(
          <ConfettiExplosion
            {...confettiOptions}
            onComplete={completeConfetti}
            particles={particles.current}
          />,
          document.body,
        )}
    </>
  );
};
